var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('h1',{staticClass:"headline mb-1"},[_c('ressource',{attrs:{"code":_vm.code}})],1),_c('v-divider',{staticClass:"my-1"}),_c('ressource',{attrs:{"code":'sous-' + _vm.code,"hide-if-empty":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }